exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".upload-file[data-v-204c96f0] .custom-file-label{border:none}", ""]);

// exports
